import React from "react";
import { useEffect, useState } from "react";
import { useIdleTimer } from "react-idle-timer";
import { useHistory } from "react-router";

export default function IdleTimer(props) {
  const [state, setState] = useState("Active");
  const [remaining, setRemaining] = useState(0);
  const history = useHistory();

  const onIdle = () => {
    setState("Idle");
    logoutUser();
  };

  const onActive = () => {
    setState("Active");
  };

  const { getRemainingTime } = useIdleTimer({
    onIdle,
    onActive,
    events: ["mousedown"],
    timeout: 7200_000,
    throttle: 500,
  });

  useEffect(() => {
    const interval = setInterval(() => {
      setRemaining(Math.ceil(getRemainingTime() / 1000));
    }, 500);

    return () => {
      clearInterval(interval);
    };
  });

  const logoutUser = () => {
    localStorage.clear();
    history.push("/login");
  };
  return (
    <>
      {
        // console.log(remaining,state)
      }
    </>
  );
}
